(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["complete-the-look"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (e) {
      var addAllBtn = e.target.closest('[data-complete-look-add-all]');
      if (!addAllBtn) return;

      var wrapper = addAllBtn.closest('.complete-look');
      if (!wrapper) return;

      var status = wrapper.querySelector('[data-complete-look-status]');
      var forms = wrapper.querySelectorAll('form[data-type="add-to-cart-form"]');
      var submitted = 0;
      var skipped = 0;

      forms.forEach(function (form) {
        var button = form.querySelector('[ref="addToCartButton"]');
        if (button && button.disabled) {
          skipped += 1;
          return;
        }
        submitted += 1;
        form.requestSubmit();
      });

      if (status) {
        status.hidden = false;
        if (submitted === 0) {
          status.textContent = 'Kies eerst kleur en maat voor elk item';
        } else if (skipped > 0) {
          status.textContent = submitted + ' toegevoegd, ' + skipped + ' overgeslagen (kies kleur/maat)';
        } else {
          status.textContent = 'Volledige look toegevoegd aan winkelwagen';
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sale-countdown')) {
    class SaleCountdown extends HTMLElement {
      connectedCallback() {
        this.endTime = parseInt(this.dataset.end, 10);
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
      }
      tick() {
        const diff = this.endTime - Date.now();
        if (diff <= 0) {
          clearInterval(this.interval);
          this.remove();
          return;
        }
        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const pad = (n) => String(n).padStart(2, '0');
        this.querySelector('[data-cd-days]').textContent = pad(days);
        this.querySelector('[data-cd-hours]').textContent = pad(hours);
        this.querySelector('[data-cd-minutes]').textContent = pad(minutes);
        this.querySelector('[data-cd-seconds]').textContent = pad(seconds);
      }
    }
    customElements.define('sale-countdown', SaleCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
